import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';

const VERIFY_EMAIL_URL = `${import.meta.env.VITE_APP_API_URL}/verify-email`;

const EmailVerify = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Parse the token from the query parameters
    const token = new URLSearchParams(location.search).get('token');

    useEffect(() => {
        if (!token) {
            enqueueSnackbar('Invalid or missing token. Redirecting to login.', {
                variant: 'solid',
                state: 'danger',
            });
            navigate('/auth/login');
            return;
        }

        // Call the API to verify the email
        const verifyEmail = async () => {
            try {
                const response = await fetch(VERIFY_EMAIL_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ token }),
                });

                if (response.ok) {
                    const result = await response.json();
                    enqueueSnackbar(result.message, {
                        variant: 'solid',
                        state: 'success',
                    });
                    navigate('/auth/email-verified'); // Redirect to email verified page
                } else {
                    const error = await response.json();
                    enqueueSnackbar(error.detail || 'An error occurred.', {
                        variant: 'solid',
                        state: 'danger',
                    });
                    navigate('/auth/login'); // Redirect to login if there's an error
                }
            } catch (error) {
                enqueueSnackbar('An unexpected error occurred. Please try again later.', {
                    variant: 'solid',
                    state: 'danger',
                });
                navigate('/auth/login');
            }
        };

        verifyEmail();
    }, [token, navigate]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <div className="text-center">
                <h3 className="text-lg font-semibold text-gray-900 mb-2.5">
                    Verifying Your Email
                </h3>
                <p className="text-gray-600">Please wait while we verify your email...</p>
            </div>
        </div>
    );
};

export { EmailVerify };
